export default {
  header: {
    title: '💛 Trinkgeld für das Team',
    subtitle: '100% geht an das Team',
  },
  buttons: {
    other: 'Andere',
    none: 'Keine',
  },
  summary_label: 'Trinkgeld',
  form: {
    custom_tip: {
      validation: {
        max: '{{value}} ist der maximale Trinkgeldwert',
      },
    },
  },
};
